import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import WorkersTableBody from './WorkersTableBody';
import type { WorkerFormRow } from '../model';

interface WorkersTableProps {
    rows: WorkerFormRow[];
    readOnly: boolean;
    rate: number;
    incomeAmount: number;
    onAmountChange: (index: number, amount: number, amountRate: number) => void;
}

const WorkersTable = ({
    rows,
    readOnly,
    rate,
    incomeAmount,
    onAmountChange,
}: WorkersTableProps) => {
    const { t } = useTranslation(['Objects']);

    return (
        <div className="crm-table-wrap">
            <Table className="ExpendTeamWorkersTable table-hover mb-0">
                <thead>
                    <tr className="bg-light">
                        <td className="head-username">{t('expendTeamWorkers.cols.user')}</td>
                        <td className="head-amount">{t('expendTeamWorkers.cols.amount')}</td>
                        <td className="head-share">{t('expendTeamWorkers.cols.share')}</td>
                        <td className="head-date">{t('expendTeamWorkers.cols.changed')}</td>
                    </tr>
                </thead>
                <WorkersTableBody
                    rows={rows}
                    readOnly={readOnly}
                    rate={rate}
                    incomeAmount={incomeAmount}
                    onAmountChange={onAmountChange}
                />
            </Table>
        </div>
    );
};

export default WorkersTable;
